export default __webpack_public_path__ + "static/media/chain.516f13e6.svg";